import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { Margin } from "@mui/icons-material";
import nopdf from "../../../assets/images/nopdf.png";
import api from "../../../utils/Url";
import { getISTDate } from "../../../utils/Constant";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "180vh",
  height: "85vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

type Props = {};

const statusOption = [
  { value: "1", label: "N/A" },
  { value: "2", label: "Issue" },
];

const FileDetailAdd = (props: Props) => {
  const { i18n, t } = useTranslation();

  const [TypeOption, setTypeOption] = useState<any>([
    { value: "-1", label: t("text.SelectFileType") },
  ]);
  const [GroupOption, setGroupOption] = useState<any>([
    { value: "-1", label: t("text.SelectFileGroup") },
  ]);
  const [CategoryOption, setCategoryOption] = useState<any>([
    { value: "-1", label: t("text.SelectFileCategory") },
  ]);
  const [ClassOption, setClassOption] = useState<any>([
    { value: "-1", label: t("text.SelectFileClass") },
  ]);
  const [SubjectOption, setSubjectOption] = useState<any>([
    { value: "-1", label: t("text.SelectFileSubject") },
  ]);
  const [SenderOption, setSenderOption] = useState<any>([
    { value: "-1", label: t("text.senderID") },
  ]);
  const [LocationOption, setLocationOption] = useState<any>([
    { value: "-1", label: t("text.currentLocation") },
  ]);
  const [nodeOption, setNodeOption] = useState<any>([
    { value: "-1", label: t("text.nodeID") },
  ]);

  const [allWards, setAllWards] = useState([]); // Store all wards
  const [ZoneOption, setZoneOption] = useState([{ value: "-1", label: t("text.SelectZone") }]);
  const [WardOption, setWardOption] = useState([{ value: "-1", label: t("text.SelectWard") }]);
  const [prevRecord, setPrevRecord] = useState<any>("");
  const [error, setError] = useState("");
  const [error1, setError1] = useState("");
  const [error2, setError2] = useState("");

  const { defaultValues, defaultValuestime } = getISTDate();

  useEffect(() => {
    getFileType();
    getFileGroup();
    getCategory();
    getFileCla();
    getFileSub();
    getSender();
    getLocation();
    getjurdiscation();
    getPrevFileData();
    getZone();
    getWard(); // This will fetch all wards initially
  }, []);



  const getWard = () => {
    const collectData = {
      wardID: -1,
      zoneID: -1, // Get all wards initially
      // user_ID: parseInt(ID),
      user_ID: -1,
    };
    api
      .post(`Ward/GetWardmaster`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          const wardName = res.data.data[index]["wardName"];
          const wardCode = res.data.data[index]["wardCode"];
          arr.push({
            label: `${wardName} (${wardCode})`,
            value: res.data.data[index]["wardID"],
            zoneID: res.data.data[index]["zoneID"] // Store zoneID with each ward
          });
        }
        setAllWards(arr); // Store all wards
        setWardOption([{ value: "-1", label: t("text.SelectWard") }, ...arr]); // Initially show all wards
      });
  };

  const getZone = () => {
    const collectData = {
      zoneID: -1,
      //  user_ID: parseInt(ID),
      user_ID: -1,
      isActive: true
    };
    api
      .post(`Zone/GetZonemaster`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["zoneName"],
            value: res.data.data[index]["zoneID"]
          });
        }
        setZoneOption([{ value: "-1", label: t("text.SelectZone") }, ...arr]);
      });
  };

  const getPrevFileData = async () => {
    const collectData = {
      fileID: -1,
      fileType: -1,
      fileGroup: -1,
      fileCategory: -1,
      fileClass: -1,
      fileSubject: -1,
      show: true,
      exportOption: "",
    };
    const response = await api.post(
      `FileDetail/GetLastDataFileDetails`,
      collectData
    );
    setPrevRecord(response.data.data);
    console.log("check", response.data.data);
  };

  const getFileType = () => {
    const collectData = {
      fileTypeId: -1,
    };
    api.post(`FileType/GetFileType`, collectData).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.fileTypeName,
        value: item.fileTypeId,
      }));
      setTypeOption(arr);
    });
  };

  const getFileGroup = () => {
    const collectData = {
      fileGroupid: -1,
    };
    api.post(`FileGroup/GetFileGroup`, collectData).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.fileGroupName,
        value: item.fileGroupid,
      }));
      setGroupOption(arr);
    });
  };

  const getCategory = () => {
    const collectData = {
      fileCatid: -1,
    };
    api.post(`FileCategory/GetFileCategory`, collectData).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.fileCatDesc,
        value: item.fileCatid,
      }));
      setCategoryOption(arr);
    });
  };

  const getFileCla = () => {
    const collectData = {
      fileClassid: -1,
    };
    api.post(`FileClass/GetFileClass`, collectData).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.classDescription,
        value: item.fileClassid,
      }));
      setClassOption(arr);
    });
  };

  const getFileSub = () => {
    const collectData = {
      id: -1,
    };
    api.post(`FileSubject/GetFileSubject`, collectData).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.fileSubjectName,
        value: item.id,
      }));
      setSubjectOption(arr);
    });
  };

  const getSender = () => {
    const collectData = {
      useR_ID: "-1",
    };
    api.post(`USER/GetUSER`, collectData).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.firsT_NAME + item.middlE_NAME + item.suR_NAME,
        value: item.useR_ID,
      }));
      setSenderOption(arr);
    });
  };

  const getLocation = () => {
    const collectData = {
      id: -1,
    };
    api.post(`LocationItems/GetMappedLocation`, collectData).then((res) => {
      const arr = res.data.data.map((item: any) => ({
        label: item.location,
        value: item.id,
      }));
      setLocationOption(arr);
    });
  };

  const getjurdiscation = () => {
    const collectData = {
      "id": -1,
      "nodeID": -1,
      "titleID": -1
    };
    api.post(`NewNodeMaster/GetNewNodeMaster`, collectData).then((res) => {
      const arr = res?.data?.data?.map((item: any) => ({
        label: item.name,
        value: item.id,
      }));
      setNodeOption(arr);
    });
  };


  const [panOpens, setPanOpen] = React.useState(false);
  const [modalImg, setModalImg] = useState("");
  const handlePanClose = () => {
    setPanOpen(false);
  };
  const modalOpenHandle = (event: any) => {
    setPanOpen(true);
    if (event === "fileDoc") {
      setModalImg(formik.values.fileDoc);
    }
  };
  const ConvertBase64 = (file: Blob) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const otherDocChangeHandler = async (event: any, params: any) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileNameParts = file.name.split(".");
      const fileExtension = fileNameParts[fileNameParts.length - 1];
      if (fileExtension.toLowerCase() === "pdf") {
        const base64 = await ConvertBase64(file);
        formik.setFieldValue(params, base64);
        console.log(base64);
      } else {
        // Display an error message indicating that only PDF files are allowed
        alert("Only PDF files are allowed to be uploaded.");
        // Optionally, you can clear the file input field
        event.target.value = null;
      }
    }
  };

  let navigate = useNavigate();

  const [toaster, setToaster] = useState(false);

  const validationSchema = Yup.object({
    chackNo: Yup.string().test(
      "required",
      t("text.reqChackNo"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    fileName: Yup.string().test(
      "required",
      t("text.reqFileName"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
       fileNo: Yup.string().test(
      "required",
      t("text.reqfileNo"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    nodeID: Yup.string().test(
      "required",
      t("text.reqJurisdiction"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),


  });

  let ID: any = localStorage.getItem("useR_ID");
  if (ID !== null) {
    ID = ID.replace(/\D/g, "");
  }


  const handleZoneChange = (event: any, newValue: any) => {
    console.log(newValue?.value);

    formik.setFieldValue("zoneID", newValue?.value);
    formik.setFieldValue("zoneName", newValue?.label);
    formik.setFieldTouched("zoneID", true);
    formik.setFieldTouched("zoneID", false);

    // Reset ward selection when zone changes
    formik.setFieldValue("wardID", "");
    formik.setFieldValue("wardName", "");

    if (newValue?.value && newValue.value !== "-1") {
      // Filter wards based on selected zone
      const filteredWards = allWards.filter((ward: any) => ward.zoneID === newValue.value);
      setWardOption([{ value: "-1", label: t("text.SelectWard") }, ...filteredWards]);
    } else {
      // Show all wards if no zone is selected or "Select Zone" is chosen
      setWardOption([{ value: "-1", label: t("text.SelectWard") }, ...allWards]);
    }
  };

  const formik = useFormik({
    initialValues: {
      fileID: -1,
      fileName: "",
      fileNo: "",
      fileType: 0,
      fileGroup: 0,
      fileCategory: 0,
      fileClass: 0,
      fileSubject: 0,
      synopsis: "",
      remark: "",
      refID: 0,
      totalPages: 0,
      fromPage: 0,
      toPage: 0,
      status: "",
      originLocation: "",
      currentLocation: "",
      zoneID: 0,
      wardID: 0,
      createdDate: defaultValuestime,
      createdBy: "",
      updatedBy: "",
      updatedDate: defaultValuestime,
      rfid: "",
      senderID: "",
      receiverID: "",
      fileDoc: "",
      fileDocbyte: "",
      chackNo: "",
      nodeID: 0,
      "registrarId": 0,
      "registrarName": "",
      "proposalNo": "",
      proposalDate: defaultValuestime
    },
    validationSchema: validationSchema,

    onSubmit: async (values) => {

      if (values.fileType === values.fileType) {
        values.fileType = prevRecord[0].fileType;
      }
      if (values.fileGroup === values.fileGroup) {
        values.fileGroup = prevRecord[0].fileGroup;
      }
      if (values.fileCategory === values.fileCategory) {
        values.fileCategory = prevRecord[0].fileCategory;
      }
      if (values.fileClass === values.fileClass) {
        values.fileClass = prevRecord[0].fileClass;
      }
      if (values.fileSubject === values.fileSubject) {
        values.fileSubject = prevRecord[0].fileSubject;
      }
      if (values.currentLocation === values.currentLocation) {
        values.currentLocation = prevRecord[0].currentLocation + "";
      }
      if (values.senderID === values.senderID) {
        values.senderID = prevRecord[0].senderID;
      }
      if (values.receiverID === values.receiverID) {
        values.receiverID = prevRecord[0].receiverID;
      }
      if (values.nodeID === values.nodeID) {
        values.nodeID = prevRecord[0].nodeID;
      }
      if (values.status === values.status) {
        values.status = prevRecord[0].status;
      }
      if (values.synopsis === values.synopsis) {
        values.synopsis = prevRecord[0].synopsis;
      }
      if (values.zoneID === values.zoneID) {
        values.zoneID = prevRecord[0].zoneID;
      }
      if (values.wardID === values.wardID) {
        values.wardID = prevRecord[0].wardID;
      }



      console.log("Before submission formik values", values);

      try {
        const response = await api.post(
          `FileDetail/AddUpdateFileDetails`,

          values
        );
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          navigate("/Library/FileDetail");
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      }

    }
  });

  const requiredFields = ["fileName", "chackNo", "nodeID","fileNo"];

  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.FileDetailsAdd")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="fileName"
                  name="fileName"
                  label={
                    <span>
                      {t("text.EnterOwnerName")}{" "}
                      {requiredFields.includes("fileName") && (
                        <span
                          style={{
                            color: formik.values.fileName ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.fileName}
                  placeholder={t("text.EnterOwnerName")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.fileName && formik.errors.fileName
                        ? "red"
                        : "initial",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.fileName && formik.errors.fileName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.fileName}
                  </div>
                ) : null}
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="synopsis"
                  name="synopsis"
                  label={t("text.EnterSynopsis")}
                  value={
                    prevRecord.length > 0
                      ? prevRecord[0]?.synopsis || ""
                      : formik.values.synopsis
                  }
                  placeholder={t("text.EnterSynopsis")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Update prevRecord
                    if (!prevRecord || prevRecord.length === 0) {
                      setPrevRecord([{ synopsis: value }]);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].synopsis = value;
                      setPrevRecord(updatedPrevRecord);
                    }

                    // Update Formik
                    formik.setFieldValue("synopsis", value);
                  }}
                  onBlur={formik.handleBlur}
                />

              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="fileNo"
                  name="fileNo"
                  // label={t("text.EnterFileNo")}
                    label={
                    <span>
                      {t("text.EnterFileNo")}{" "}
                      {requiredFields.includes("fileNo") && (
                        <span
                          style={{
                            color: formik.values.fileNo ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.fileNo}
                  placeholder={t("text.EnterFileNo")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                 {formik.touched.fileNo && formik.errors.fileNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.fileNo}
                  </div>
                ) : null}
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="chackNo"
                  name="chackNo"
                  label={
                    <span>
                      {t("text.EnterChackNo")}{" "}
                      {requiredFields.includes("chackNo") && (
                        <span
                          style={{
                            color: formik.values.chackNo ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.chackNo}
                  placeholder={t("text.EnterChackNo")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.chackNo && formik.errors.chackNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.chackNo}
                  </div>
                ) : null}
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="totalPages"
                  name="totalPages"
                  label={t("text.EnterTotalPage")}
                  value={formik.values.totalPages}
                  placeholder={t("text.EnterTotalPage")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  //onChange={formik.handleChange}
                  onChange={(e: any) => {
                    const inputValue = e.target.value;

                    if (/^\d*$/.test(inputValue)) {
                      formik.setFieldValue("totalPages", inputValue);
                      setError("");
                    } else {
                      setError("* Only number are allowed.");
                    }
                  }}
                  onBlur={formik.handleBlur}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                />
                <FormHelperText error sx={{ marginLeft: "10px", fontSize: "12px" }}>{error}</FormHelperText>
              </Grid>

              {/* <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="fromPage"
                  name="fromPage"
                  label={t("text.EnterFromPage")}
                  value={formik.values.fromPage}
                  placeholder={t("text.EnterFromPage")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={(e: any) => {
                    const inputValue = e.target.value;

                    if (/^\d*$/.test(inputValue)) {
                      formik.setFieldValue("fromPage", inputValue);
                      setError1("");
                    } else {
                      setError1("* Only number are allowed.");
                    }
                  }}
                  onBlur={formik.handleBlur}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                />
                <FormHelperText error sx={{ marginLeft: "10px", fontSize: "12px" }}>{error1}</FormHelperText>
              </Grid> */}

              {/* <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="toPage"
                  name="toPage"
                  label={t("text.EnterToPage")}
                  value={formik.values.toPage}
                  placeholder={t("text.EnterToPage")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={(e: any) => {
                    const inputValue = e.target.value;

                    if (/^\d*$/.test(inputValue)) {
                      console.log("value", inputValue);
                      formik.setFieldValue("toPage", inputValue);
                      setError2("");
                    } else {
                      setError2("* Only number are allowed.");
                    }
                  }}
                  onBlur={formik.handleBlur}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                />
                <FormHelperText error sx={{ marginLeft: "10px", fontSize: "12px" }}>{error2}</FormHelperText>
              </Grid> */}

              {/* <Grid item sm={4} md={4} xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="status">{t("text.EnterStatus")}</InputLabel>
                  <Select
                    id="status"
                    name="status"
                    // value={formik.values.status}
                    labelId="status"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    {statusOption.map((option: any) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              <Grid item sm={4} md={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={statusOption}
                  value={
                    prevRecord.length > 0
                      ? statusOption.find(
                        (option: any) =>
                          option.value === prevRecord[0]?.status
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [{ status: newValue?.value }];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].status = newValue?.value;
                      setPrevRecord(updatedPrevRecord);
                    }
                    formik.setFieldValue("status", newValue?.value);
                    formik.setFieldTouched("status", true);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.EnterStatus")} />
                  )}
                />
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="rfid"
                  name="rfid"
                  label={t("text.EnterRFID")}
                  value={formik.values.rfid}
                  placeholder={t("text.EnterRFID")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={TypeOption}
                  value={
                    prevRecord.length > 0
                      ? TypeOption.find(
                        (option: any) =>
                          option.value === prevRecord[0]?.fileType
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [{ fileType: newValue?.value }];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].fileType = newValue?.value;
                      setPrevRecord(updatedPrevRecord);
                    }
                    formik.setFieldValue("fileType", newValue?.value);
                    formik.setFieldTouched("fileType", true);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectFileType")} />
                  )}
                />
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={GroupOption}
                  value={
                    prevRecord.length > 0
                      ? GroupOption.find(
                        (option: any) =>
                          option.value === prevRecord[0]?.fileGroup
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    if (!newValue) {
                      formik.setFieldValue("fileGroup", prevRecord[0]?.fileGroup);
                    } else {
                      if (!prevRecord || prevRecord.length === 0) {
                        const updatedPrevRecord = [{ fileGroup: newValue?.value }];
                        setPrevRecord(updatedPrevRecord);
                      } else {
                        let updatedPrevRecord = [...prevRecord];
                        updatedPrevRecord[0].fileGroup = newValue?.value;
                        setPrevRecord(updatedPrevRecord);
                      }
                      formik.setFieldValue("fileGroup", newValue?.value);
                    }
                    formik.setFieldTouched("fileGroup", true);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectFileGroup")} />
                  )}
                />
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={CategoryOption}
                  value={
                    prevRecord.length > 0
                      ? CategoryOption.find(
                        (option: any) =>
                          option.value === prevRecord[0]?.fileCategory
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);

                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [
                        { fileCategory: newValue?.value },
                      ];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].fileCategory = newValue?.value;
                      setPrevRecord(updatedPrevRecord);
                    }
                    formik.setFieldValue("fileCategory", newValue?.value);
                    formik.setFieldTouched("fileCategory", true);
                    formik.setFieldTouched("fileCategory", false);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectFileCategory")}
                    />
                  )}
                />
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={ClassOption}
                  value={
                    prevRecord.length > 0
                      ? ClassOption.find(
                        (option: any) =>
                          option.value === prevRecord[0]?.fileClass
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);

                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [
                        { fileClass: newValue?.value },
                      ];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].fileClass = newValue?.value;
                      setPrevRecord(updatedPrevRecord);
                    }

                    formik.setFieldValue("fileClass", newValue?.value);
                    formik.setFieldTouched("fileClass", true);
                    formik.setFieldTouched("fileClass", false);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectFileClass")}
                    />
                  )}
                />
              </Grid>

              <Grid item sm={4} md={4} xs={12} spacing={3}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={SubjectOption}
                  value={
                    prevRecord.length > 0
                      ? SubjectOption.find(
                        (option: any) =>
                          option.value === prevRecord[0]?.fileSubject
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);

                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [
                        { fileSubject: newValue?.value },
                      ];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].fileSubject = newValue?.value;
                      setPrevRecord(updatedPrevRecord);
                    }
                    formik.setFieldValue("fileSubject", newValue?.value);
                    formik.setFieldTouched("fileSubject", true);
                    formik.setFieldTouched("fileSubject", false);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectFileSubject")}
                    />
                  )}
                />
              </Grid>

              <Grid item sm={4} md={4} xs={12} spacing={3}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={SenderOption}
                  value={
                    prevRecord.length > 0
                      ? SenderOption.find(
                        (option: any) =>
                          option.value === prevRecord[0]?.senderID
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);

                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [{ senderID: newValue?.value }];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].senderID = newValue?.value;
                      setPrevRecord(updatedPrevRecord);
                    }

                    formik.setFieldValue("senderID", newValue?.value);
                    formik.setFieldTouched("senderID", true);
                    formik.setFieldTouched("senderID", false);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.senderID")}
                    />
                  )}
                />
              </Grid>

              <Grid item sm={4} md={4} xs={12} spacing={3}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={SenderOption}
                  value={
                    prevRecord.length > 0
                      ? SenderOption.find(
                        (option: any) =>
                          option.value === prevRecord[0]?.receiverID
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [
                        { receiverID: newValue?.value },
                      ];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].receiverID = newValue?.value;
                      setPrevRecord(updatedPrevRecord);
                    }
                    formik.setFieldValue("receiverID", newValue?.value);
                    formik.setFieldTouched("receiverID", true);
                    formik.setFieldTouched("receiverID", false);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.receiverID")}
                    />
                  )}
                />
              </Grid>

              <Grid item sm={4} md={4} xs={12} spacing={3}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={LocationOption}
                  value={
                    prevRecord.length > 0
                      ? LocationOption.find(
                        (option: any) =>
                          option.value ===
                          parseInt(prevRecord[0]?.currentLocation)
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [
                        { currentLocation: newValue?.value },
                      ];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].currentLocation = newValue?.value;
                      setPrevRecord(updatedPrevRecord);
                    }
                    formik.setFieldValue(
                      "currentLocation",
                      newValue?.value + ""
                    );
                    formik.setFieldTouched("currentLocation", true);
                    formik.setFieldTouched("currentLocation", false);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.currentLocation")}
                    />
                  )}
                />
              </Grid>



              <Grid item sm={4} md={4} xs={12} spacing={3}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={nodeOption}
                  value={
                    prevRecord.length > 0
                      ? nodeOption.find(
                        (option: any) =>
                          option.value ===
                          parseInt(prevRecord[0]?.nodeID)
                      ) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [
                        { nodeID: newValue?.value },
                      ];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].nodeID = newValue?.value;
                      setPrevRecord(updatedPrevRecord);
                    }
                    formik.setFieldValue(
                      "nodeID",
                      newValue?.value + ""
                    );
                    formik.setFieldTouched("nodeID", true);
                    formik.setFieldTouched("nodeID", false);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={
                      <span>
                        {t("text.nodeID")} {" "}
                        {requiredFields.includes("nodeID") && (
                          <span
                            style={{
                              color: formik.values.nodeID
                                ? "green" : "red",
                            }}
                          >
                            *
                          </span>
                        )}
                      </span>
                    }
                    />
                  )}
                />
                {formik.touched.nodeID && formik.errors.nodeID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.nodeID}
                  </div>
                ) : null}
              </Grid>
              <Grid item sm={4} md={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="zone-select"
                  options={ZoneOption.filter(option => option.value !== "-1")}
                  value={
                    prevRecord.length > 0
                      ? ZoneOption.find(option => option.value === prevRecord[0]?.zoneID) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    const selectedZoneID = newValue?.value;

                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [{ zoneID: selectedZoneID }];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].zoneID = selectedZoneID;
                      setPrevRecord(updatedPrevRecord);
                    }

                    formik.setFieldValue("zoneID", selectedZoneID);
                    formik.setFieldTouched("zoneID", true);
                    formik.setFieldTouched("zoneID", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectZoneName")}{" "}
                          {requiredFields.includes("zoneName") && (
                            <span style={{ color: formik.values.zoneID ? "green" : "red" }}>*</span>
                          )}
                        </span>
                      }
                    />
                  )}
                />

                {formik.touched.zoneID && formik.errors.zoneID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.zoneID}
                  </div>
                ) : null}
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="ward-select"
                  options={WardOption.filter(option => option.value !== "-1")}
                  value={
                    prevRecord.length > 0
                      ? WardOption.find(option => option.value === prevRecord[0]?.wardID) || null
                      : null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    const selectedWardID = newValue?.value;
                    const selectedWardName = newValue?.label;

                    if (!prevRecord || prevRecord.length === 0) {
                      const updatedPrevRecord = [{ wardID: selectedWardID }];
                      setPrevRecord(updatedPrevRecord);
                    } else {
                      let updatedPrevRecord = [...prevRecord];
                      updatedPrevRecord[0].wardID = selectedWardID;
                      setPrevRecord(updatedPrevRecord);
                    }

                    formik.setFieldValue("wardID", selectedWardID);
                    formik.setFieldValue("wardName", selectedWardName);
                    formik.setFieldTouched("wardID", true);
                    formik.setFieldTouched("wardID", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectWardName")}{" "}
                          {requiredFields.includes("wardName") && (
                            <span style={{ color: formik.values.wardID ? "green" : "red" }}>*</span>
                          )}
                        </span>
                      }
                    />
                  )}
                />

                {formik.touched.wardID && formik.errors.wardID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.wardID}
                  </div>
                ) : null}
              </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="registrarName"
                  name="registrarName"
                  label={t("text.RegistrarName")}
                  value={formik.values.registrarName}
                  placeholder={t("text.RegistrarName")}
                  inputProps={{}}
                  size="small"
                  type="text"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>


              <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="proposalNo"
                  name="proposalNo"
                  label={t("text.ProposalNo")}
                  value={formik.values.proposalNo}
                  placeholder={t("text.ProposalNo")}
                  inputProps={{}}
                  size="small"
                  type="text"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>


                <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="proposalDate"
                  name="proposalDate"
                  label={t("text.ProposalDate")}
                  value={formik.values.proposalDate ? formik.values.proposalDate.split("T")[0] : new Date().toISOString().split("T")[0]}
                  placeholder={t("text.ProposalDate")}
                  inputProps={{}}
                  size="small"
                  type="date"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{ shrink: true }}
                />
                </Grid>

              <Grid item sm={4} md={4} xs={12}>
                <TextField
                  id="remark"
                  name="remark"
                  label={t("text.EnterRemark")}
                  value={formik.values.remark}
                  placeholder={t("text.EnterRemark")}
                  inputProps={{}}
                  size="small"
                  type="text"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid container spacing={1} item>
                <Grid
                  xs={12}
                  md={4}
                  sm={4}
                  item
                  style={{ marginBottom: "30px", marginTop: "30px" }}
                >
                  <TextField
                    type="file"
                    inputProps={{ accept: "application/pdf" }}
                    InputLabelProps={{ shrink: true }}
                    label={
                      <strong style={{ color: "#000" }}>
                        {t("text.AttachedFile")}
                      </strong>
                    }
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={(e) => otherDocChangeHandler(e, "fileDoc")}
                  />
                </Grid>
                <Grid xs={12} md={4} sm={4} item></Grid>

                <Grid xs={12} md={4} sm={4} item>
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                      margin: "10px",
                    }}
                  >
                    {formik.values.fileDoc == "" ? (
                      <img
                        src={nopdf}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                        }}
                      />
                    ) : (
                      <embed
                        src={formik.values.fileDoc}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                          padding: "2px",
                        }}
                      />
                    )}
                    <Typography
                      onClick={() => modalOpenHandle("fileDoc")}
                      style={{
                        textDecorationColor: "blue",
                        textDecorationLine: "underline",
                        color: "blue",
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    >
                      {t("text.Preview")}
                    </Typography>
                  </Grid>
                </Grid>
                <Modal open={panOpens} onClose={handlePanClose}>
                  <Box sx={style}>
                    {modalImg == "" ? (
                      <img
                        src={nopdf}
                        style={{
                          width: "170vh",
                          height: "75vh",
                        }}
                      />
                    ) : (
                      <div style={{ width: "100%", height: "100%" }}>
                        <embed
                          src={modalImg}
                          type="application/pdf"
                          width="100%"
                          height="100%"
                          style={{ borderRadius: 10 }}
                        />
                      </div>
                    )}
                  </Box>
                </Modal>
              </Grid>

              <Grid
                item
                xs={12}
                spacing={2}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Grid xs={6} style={{ margin: "6px" }}>
                  <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: "#059669",
                    color: "white",
                    marginTop: "10px",
                  }}
                  disabled={formik.isSubmitting}
                  >
                  {formik.isSubmitting ? (
                    <span>
                    <span
                      className="MuiCircularProgress-root MuiCircularProgress-indeterminate"
                      style={{
                      display: "inline-block",
                      verticalAlign: "middle",
                      marginRight: 8,
                      width: 20,
                      height: 20,
                      }}
                    >
                      <svg
                      viewBox="22 22 44 44"
                      style={{ width: 20, height: 20 }}
                      >
                      <circle
                        className="MuiCircularProgress-circle"
                        cx="44"
                        cy="44"
                        r="20.2"
                        fill="none"
                        strokeWidth="3.6"
                        stroke="#fff"
                      />
                      </svg>
                    </span>
                    {t("text.saving") || "Saving..."}
                    </span>
                  ) : (
                    t("text.save")
                  )}
                  </Button>
                </Grid>

                <Grid xs={6} style={{ margin: "6px" }}>
                  <Button
                    type="reset"
                    fullWidth
                    style={{
                      backgroundColor: "#F43F5E",
                      color: "white",
                      marginTop: "10px",
                    }}
                    onClick={(e) => formik.resetForm()}
                  >
                    {t("text.reset")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default FileDetailAdd;